<script>
	import Router from 'svelte-spa-router';
	import { routes } from './routes';
	// @ts-ignore
	import { Toaster } from 'svelte-french-toast';
	import LoaderCover from './lib/components/LoaderCover.svelte';
	import NetWorkErrorFixedToast from './lib/components/NetWorkErrorFixedToast.svelte';
  import { onMount } from 'svelte';
  import { is_2nd_store } from './lib/scripts/util';

	function routeLoaded() {
		// console.log('route-loaded');
	}

	function conditionsFailed() {
		// console.log('conditions-failed');
	}

	onMount(() => {
		const _title = import.meta.env.VITE_APP_TITLE;
		document.querySelector('title').text = _title;
		document.querySelector('#lnk-icon').setAttribute('href', is_2nd_store? '/logo-2.svg':'/logo-1.svg');
	})
</script>

<Router {routes} on:conditionsFailed={conditionsFailed} on:routeLoaded={routeLoaded} />
<Toaster />
<LoaderCover />
<NetWorkErrorFixedToast />
